// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__ulGah","main":"Layout_main__FxQfo"};